const Config = {
    captchaSiteKey: '6LeBZyUhAAAAAABmllnbNScjKM0GuvhyxGCku4eK',
};

export default Config